import React, { useEffect, useState } from 'react';
import { IProperty } from '../utils/JsonApiRequest';
import PropertyRequest from '../utils/PropertyRequest';

export interface IPropertyDetailHintProps {
    id: IProperty['drupal_internal__id'];
}

const PropertyDetailHint: React.FC<React.PropsWithChildren<IPropertyDetailHintProps>> = ({ id = null }) => {
    const [text, setText] = useState<string>('');
    useEffect(() => {
        PropertyRequest.getStatistic(id)
            .then((stat) => {
                if (stat.contactRequests === 0) {
                    setText('Noch 0 Anfragen. Sei der Erste.');
                } else {
                    setText('');
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }, [id]);
    return <>{text}</>;
};

export default PropertyDetailHint;
